<template>
  <div class="sidebar">
    <list></list>
  </div>
</template>
<script>
import Card from "./components/card";
import List from "./components/list";
import MessageText from "./components/messagetext";
import Message from "./components/message";
import ContactInfo from "./components/contactinfo";
import { mapState } from "vuex";
export default {
  components: { Card, List, MessageText, Message, ContactInfo },
  computed: {
    ...mapState({
      user: (state) => state.chat.user,
    }),
  },
  props: {
    contactId: String,
  },
  created() {
    this.initPage();
  },
  methods: {
    async initPage() {
      // if (!this.user) {
      //   await this.getUserInfoFn();
      // }
      if (this.contactId) {
        await this.$store.dispatch("initChatData", { id: this.contactId });
      } else {
        await this.$store.dispatch("initData");
      }
    },
    //获取用户信息
    // async getUserInfoFn() {
    //   if (this.loading) return;
    //   const { status, data, message } = await this.$api.comApi.getUserInfo();
    //   if (status === "0") {
    //     this.$store.commit("SET_USERINFO", data);
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
.sidebar {
  width: 100%;
  height: 100%;
  max-width: 374px;
  color: #f4f4f4;
  background-color: #fff;
  // border-right: 1px solid #dbd9d6;
}
</style>
